<template>
  <div class="partner-preview">
    <BasePreloader v-if="pendingDelete"/>

    <picture v-if="partner.customer_data.avatar" class="partner-preview__img-wrap">
      <img :src="partner.customer_data.avatar" alt="user">
    </picture>
    <div v-else class="partner-preview__img-wrap  _placeholder"
         style="background-color: #b3a3c1">
      {{ abbrName }}
    </div>
    <button @click.stop="$emit('open-agent-registered-show', partner.customer_data.id)"
            class="partner-preview__show-invite">
      <BaseSvg name="ico-help"/>
    </button>
    <button v-if="!partner.jobseekers && !partner.partners"
            @click.stop="onDelete"
            class="partner-preview__delete">
      <BaseSvg name="ico-trash"/>
    </button>
    <div class="partner-preview__main">
      <h4 class="partner-preview__title">
        {{ partner.customer_data.fullname_forshow || $tPartners('No name') }}
      </h4>
      <time :datetime="partner.created_at | formatDateForTimeTag"
            class="partner-preview__time-from">
        {{ $tPartners('Partner from') }} {{ partner.created_at  | formatDate }}
      </time>
      <div class="partner-preview__props">
        <div class="partner-preview__prop  _person-plus">
          <BaseSvg name="ico-person-plus"
                   width="2rem" height="1.4rem"/>
          {{ partner.jobseekers }}
        </div>
      </div>
      <div class="partner-preview__money-title">{{ $tPartners('Brought income') }}</div>
      <div :class="!partner.income ? '_disabled' : null" class="partner-preview__money">
        <strong>{{ partner.income }}</strong>
        JBN
      </div>
    </div>
  </div>
</template>

<script>
  import handleError from '@/helpers/handleError'
  import {http} from "@/axios"

  export default {
    props: {
      partner: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        pendingDelete: false,
        showContacts: false,
      }
    },
    computed: {
      abbrName() {
        const p = this.partner.customer_data
        const first = p.firstname && p.firstname.charAt(0)
        const second = p.lastname && p.lastname.charAt(0)
        return first + second || null
      }
    },
    methods: {
      onDelete() {
        this.$vModal.open('confirm', {
          title: this.$tPartners('Delete partner?'),
          onAccept: () => {
            this.deleteAgent()
            this.$vModal.close('confirm')
          }
        })
      },
      deleteAgent() {
        this.pendingDelete = true

        http.delete(`/api/cabinet/agent/remove-agent/${this.partner.customer_data.id}`)
            .then(() => {
              this.$emit('refresh')
            })
            .catch(e => {
              this.$vModal.open('warning', {
                title: handleError(e)
              })
            })
            .finally(() => {
              this.pendingDelete = false
            })
      }
    }
  }
</script>

<style lang="less">

</style>
